import React from 'react';

const Address = () => {
  return (
    <>
      <p className="open-sans-font custom-span-contact position-relative">
        <i className="fa fa-map position-absolute"></i>
        <span className="d-block">Address Point</span>KArachi, Pakistan
      </p>
      {/* End .custom-span-contact */}

      <p className="open-sans-font custom-span-contact position-relative">
        <i className="fa fa-envelope-open position-absolute"></i>
        <span className="d-block">mail me</span>{' '}
        <a href="mailto:steve@mail.com">attaurrahmanfarooqi9@gmail.com</a>
      </p>
      {/* End .custom-span-contact */}

      <p className="open-sans-font custom-span-contact position-relative">
        <i className="fa fa-phone-square position-absolute"></i>
        <span className="d-block">whatsapp me</span>{' '}
        <a href="Tel: +92 319 2400141">+92 319 2400141</a>
      </p>
      {/* End .custom-span-contact */}
    </>
  );
};

export default Address;
